<template>
  <Slider></Slider>
  <div class="home-container">
    <el-row :gutter="20" class="row">
      <el-col :span="16">
        <!--头条-->
        <template v-for="(item, index) in listData" :key="index">
          <Headlines v-if="item.position == '6'" :list="item"></Headlines>
        </template>

        <!--新闻列表-->
        <div class="new-list">
          <Trend :list="trendData"></Trend>
          <template v-for="(item, index) in listData.sort((a, b) => { return a.position - b.position })" :key="index">
            <News v-if="[2,3,4,5].includes(item.position)" :list="item" class="news-spacing"></News>
          </template>
        </div>

      </el-col>
      <el-col :span="8">
        <!--学员入口-->
        <Entrance></Entrance>

        <!--右侧列表-->
        <div class="notice-list">
          <template v-for="(item, index) in listData" :key="index">
            <Notice  v-if="item.position == '6'" :list="item"></Notice>
          </template>
        </div>
        <Special :list="listSpecial"></Special>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <Ad></Ad>
      </el-col>
    </el-row>

    <div style="height: 10px;"></div>

    <el-row :gutter="20">
      <el-col :span="16">
        <template v-for="(item, index) in listData" :key="index">
          <BaseSwiper v-if="item.position == '7'" :list="item"></BaseSwiper>
        </template>
      </el-col>
      <el-col :span="8">
        <template v-for="(item, index) in listData" :key="index">
          <Show v-if="item.position == '8'" :list="item"></Show>
        </template>
      </el-col>
    </el-row>

    <div style="height: 10px;"></div>

    <el-row>
      <el-col :span="24">
        <FriendLink></FriendLink>
      </el-col>
    </el-row>
    <div style="height: 10px;"></div>
  </div>
</template>

<script>
import api from '../api/api';
//import { useStore } from 'vuex'
import Headlines from '../components/Headlines'
import Entrance from '../components/Entrance'
import News from '../components/News'
import Trend from '../components/Trend'
import Notice from '../components/Notice'
import Special from '../components/Special'
import Ad from '../components/Ad'
import BaseSwiper from '../components/BaseSwiper'
import FriendLink from '../components/FriendLink'
import Slider from "../components/Slider";
import Show from "../components/Show";

export default {
  name: "Home",
  components: { Headlines, Entrance, News, Trend, Notice, Special, Ad, FriendLink,BaseSwiper,Slider, Show },

  data() {
    return {
      list: {
        contents1: {},
        contents2: Object,
        contents3: Object,
        contents4: Object,
        contents5: Object,
        contents6: Object,
        contents7: Object,
        contents8: Object,
        notices:Object,
        headline:Object
      }
      ,listData:[]
      ,trendData:[]
      ,listSpecial:[]
    }
  },
  async mounted() {
    let json = await api.common.index()
    let trend = await api.common.trend()
    let special = await api.common.special()

    this.listData = json.data
    this.trendData = trend.data
    console.log(this.trendData)
    this.listSpecial = special.data
  }
}
</script>

<style scoped>
.row:first-child, row:nth-child(2){

}
.new-list {
  margin: 15px 0 15px 0;
}
.notice-list {
  margin: 15px 0 15px 0;
}
.news-spacing:nth-child(odd) {
  margin-left: 18px;
}
.list-special {
  width: 205px;
  display: block;
  height: 45px!important;
  margin: 4px 0;
}
.list-special img{
  width: 100%;
}
.foot-list /deep/.el-tabs__item {
  padding: 0;
  text-align: center!important;
  width: 80px;
  height: 60px;
}
.foot-list /deep/.el-tabs__active-bar {
  display: none;
}
.foot-list /deep/#tab-party-first{
  background: url("../assets/images/party_bg.png") no-repeat;
  background-size: 95%;
  background-position: 0px 2px;
}
.foot-list /deep/#tab-party-second{
  background: url("../assets/images/party_bg.png") no-repeat;
  background-size: 95%;
  background-position: 0px -72px;
}
.foot-list /deep/#tab-party-third{
  background: url("../assets/images/party_bg.png") no-repeat;
  background-size: 95%;
  background-position: 0px -145px;
}
/deep/.el-tabs--left .el-tabs__nav-wrap.is-left::after{
  width: 0px;
}
.home-container {
  width: 1200px;
  background-color: #fff;
  margin-top: 1rem;
}

</style>